import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import PageHero from '../../components/feature/PageHero';
import CountdownTimer from '../../components/feature/CountdownTimer';
import SEOHead from '../../components/feature/SEOHead';

const services = [
  {
    icon: 'ri-car-line',
    title: 'Contratação Profissional de Seguro Automóvel',
    description: 'Análise detalhada de riscos, seleção precisa de coberturas e negociação especializada para proteger seu veículo com economia.',
    link: '/servicos/automovel',
    benefits: ['Redução de até 30% no custo', 'Coberturas adequadas ao perfil', 'Negociação com múltiplas seguradoras']
  },
  {
    icon: 'ri-shield-user-line',
    title: 'Avaliação Financeira – Vida Empresarial',
    description: 'Proteção patrimonial para empresários e sócios com análise de riscos financeiros e estruturação de coberturas estratégicas.',
    link: '/servicos/vida-empresarial',
    benefits: ['Proteção do patrimônio empresarial', 'Sucessão planejada', 'Garantia de continuidade do negócio']
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Gestão Financeira de Contratos de Seguros',
    description: 'Acompanhamento contínuo, revisão de apólices e otimização de custos para garantir condições sempre vantajosas.',
    link: '/servicos/gestao-contratos',
    benefits: ['Economia recorrente', 'Revisão anual de coberturas', 'Controle total dos contratos']
  },
  {
    icon: 'ri-hand-coin-line',
    title: 'Recuperação de Sinistros',
    description: 'Suporte técnico especializado na análise e recuperação de valores em processos de sinistros junto às seguradoras.',
    link: '/servicos/recuperacao-sinistros',
    benefits: ['Maximização de indenizações', 'Agilidade no processo', 'Defesa técnica dos seus direitos']
  },
  {
    icon: 'ri-lightbulb-line',
    title: 'Consultoria Técnica',
    description: 'Orientação especializada para tomada de decisão estratégica na contratação e gestão de seguros corporativos.',
    link: '/servicos/consultoria-tecnica',
    benefits: ['Análise de riscos corporativos', 'Planejamento estratégico', 'Decisões fundamentadas']
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Suporte e Acompanhamento',
    description: 'Atendimento contínuo e personalizado durante toda a vigência dos contratos com monitoramento ativo.',
    link: '/servicos/suporte-acompanhamento',
    benefits: ['Atendimento prioritário', 'Monitoramento contínuo', 'Suporte em sinistros']
  }
];

export default function ServicosPage() {
  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Serviços de Consultoria em Seguros Empresariais",
    "description": "Conheça nossos serviços especializados: consultoria técnica, gestão de contratos, recuperação de sinistros e seguros empresariais personalizados.",
    "url": "https://ibxbrasil.com.br/servicos"
  };

  return (
    <>
      <SEOHead
        title="Serviços de Consultoria em Seguros Empresariais | IBX Brasil"
        description="Consultoria técnica, gestão de contratos, recuperação de sinistros, seguros de vida empresarial, automóvel, incêndio e suporte especializado para sua empresa."
        canonical="https://ibxbrasil.com.br/servicos"
        ogImage="https://readdy.ai/api/search-image?query=comprehensive%20business%20insurance%20services%20portfolio%20with%20professional%20consulting%20team%20analyzing%20corporate%20protection%20solutions&width=1200&height=630&seq=ibx-servicos-og&orientation=landscape"
        schema={webPageSchema}
      />
      <div className="min-h-screen bg-white">
        <Navbar />
        
        {/* Hero Section */}
        <PageHero
          badge="NOSSOS SERVIÇOS"
          title="Soluções Completas em Gestão de Riscos"
          highlightedWord="Riscos"
          highlightColor="green"
          subtitle="Cada serviço é estruturado para garantir proteção patrimonial e economia inteligente através de contratação profissional de seguros."
          benefits={[
            'Análise técnica detalhada de riscos',
            'Negociação estratégica com seguradoras',
            'Acompanhamento contínuo e personalizado'
          ]}
          ctaText="Solicitar Análise Gratuita"
          ctaLink="/#contato"
          ctaSecondary={{
            text: 'Falar no WhatsApp',
            link: 'https://wa.me/5577988080505'
          }}
          backgroundImage="https://readdy.ai/api/search-image?query=professional%20insurance%20consulting%20team%20analyzing%20risk%20management%20documents%20in%20modern%20corporate%20office%20with%20multiple%20monitors%20showing%20data%20charts%20and%20financial%20analysis%20with%20warm%20natural%20lighting%20and%20clean%20minimalist%20workspace%20environment%20representing%20security%20and%20expertise&width=1920&height=800&seq=servicos-hero-001&orientation=landscape"
          overlayOpacity="medium"
        />

        {/* Services Grid */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {services.map((service, index) => (
                <Link
                  key={index}
                  to={service.link}
                  className="group bg-white border border-gray-200 rounded-lg p-8 hover:border-orange-500 hover:shadow-xl transition-all duration-300 cursor-pointer"
                >
                  <div className="w-16 h-16 bg-orange-100 rounded-lg flex items-center justify-center mb-6 group-hover:bg-orange-500 transition-colors duration-300">
                    <i className={`${service.icon} text-3xl text-orange-600 group-hover:text-white transition-colors duration-300`}></i>
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-orange-600 transition-colors duration-300">
                    {service.title}
                  </h3>
                  
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {service.description}
                  </p>
                  
                  <div className="space-y-2 mb-6">
                    {service.benefits.map((benefit, idx) => (
                      <div key={idx} className="flex items-start gap-2">
                        <i className="ri-check-line text-orange-600 text-lg mt-0.5"></i>
                        <span className="text-sm text-gray-600">{benefit}</span>
                      </div>
                    ))}
                  </div>
                  
                  <a
                    href={service.link}
                    className="inline-flex items-center justify-center px-6 py-3 bg-action-orange-500 text-white font-semibold rounded-lg hover:bg-action-orange-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
                  >
                    Saiba Mais
                    <i className="ri-arrow-right-line ml-2"></i>
                  </a>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Why Choose Section */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Por Que Escolher a IBX Brasil?
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Décadas de experiência em gestão de riscos e contratação profissional de seguros
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-4xl text-orange-600"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Análise Detalhada</h3>
                <p className="text-gray-600 text-sm">Mapeamento completo de riscos e necessidades específicas</p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-team-line text-4xl text-orange-600"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Negociação Especializada</h3>
                <p className="text-gray-600 text-sm">Relacionamento direto com seguradoras e corretores</p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-money-dollar-circle-line text-4xl text-orange-600"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Economia Comprovada</h3>
                <p className="text-gray-600 text-sm">Redução de custos sem comprometer a proteção</p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-customer-service-line text-4xl text-orange-600"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Acompanhamento Contínuo</h3>
                <p className="text-gray-600 text-sm">Suporte durante toda a vigência dos contratos</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-orange-600 to-orange-700">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-4xl font-bold text-white mb-6">
              Pronto para Profissionalizar a Contratação dos Seus Seguros?
            </h2>
            <p className="text-xl text-orange-100 mb-8">
              Solicite uma análise gratuita e descubra como podemos proteger seu patrimônio com economia inteligente
            </p>
            
            {/* Countdown Timer */}
            <div className="mb-8">
              <CountdownTimer location="servicos" />
            </div>

            <div className="flex flex-wrap justify-center gap-4">
              <a
                href="https://wa.me/5577988080505"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-white text-orange-600 rounded-lg font-semibold hover:bg-orange-50 transition-colors duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
                <span>Falar no WhatsApp</span>
              </a>
              <a
                href="/contato"
                className="inline-flex items-center gap-2 px-8 py-4 bg-strategic-green-500 text-white font-semibold rounded-lg transition-all duration-300 hover:bg-strategic-green-600 hover:scale-105 hover:shadow-xl whitespace-nowrap"
              >
                Solicitar Cotação
                <i className="ri-arrow-right-line text-xl"></i>
              </a>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}